import PageWrapper from "components/ui/PageWrapper";
import BookRowRanked from "components/Bookcards/BookRowRanked/BookRowRanked";
import { BookSerializersBookByline } from "types/serializers";
import Pagination, { PaginationPageProps } from "components/shared/Pagination";
import { usePage } from "@inertiajs/react";

export default function TrendingBooks({
  books,
}: {
  books: BookSerializersBookByline[];
}) {
  const { pagination } = usePage<PaginationPageProps>().props;

  const offset =
    pagination.currentPage >= 2
      ? (pagination.currentPage - 1) * pagination.perPage
      : 0;
  return (
    <PageWrapper>
      <div className="divide-y divide-secondary">
        {books.map((book, index) => (
          <BookRowRanked
            size="md"
            className="py-4"
            book={book}
            key={`book-${book.id}`}
            rank={offset + index + 1}
          />
        ))}
      </div>

      <Pagination />
    </PageWrapper>
  );
}
